var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M20,4c1.1,0,2,0.9,2,2l0,0v12c0,1.1-0.9,2-2,2l0,0H4c-1.1,0-2-0.9-2-2l0,0L2,6c0-1.1,0.9-2,2-2l0,0H20z  M6.5,8.7H3.8V15h1.6v-1.9h1.2c0.7,0,1.3-0.2,1.8-0.6c0.4-0.4,0.7-0.9,0.7-1.6c0-0.7-0.2-1.2-0.7-1.6S7.3,8.7,6.5,8.7z M11.8,8.7 H9.6V15h2.2c1.1,0,1.9-0.3,2.5-0.8c0.6-0.5,0.9-1.3,0.9-2.4c0-0.6-0.1-1.2-0.4-1.7c-0.3-0.5-0.7-0.8-1.2-1.1S12.5,8.7,11.8,8.7z  M20.4,8.7H16V15h1.6v-2.5h2.1v-1.3h-2.1V10h2.9V8.7z M12,10c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.4,0.8,0.4,1.3c0,0.6-0.1,1-0.4,1.3 c-0.3,0.3-0.7,0.5-1.3,0.5h-0.8V10H12z M6.3,10c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.3,0.3,0.7S7.2,11.4,7,11.6s-0.4,0.2-0.8,0.2 H5.3V10H6.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdf);
export default __webpack_public_path__ + "static/media/ic_PDF.5c12773d.svg";
export { ForwardRef as ReactComponent };